/**
 * LegalLinks — 개인정보처리방침 · 이용 규정 링크 한 줄 (2026-10-23).
 *
 * - 두 문서는 로그인 없이 여는 정적 페이지(web/public/privacy.html · terms.html)라 SPA 라우터가 아닌 새 탭 링크.
 * - 두 링크는 글꼴·굵기·색을 똑같이 둔다(2026-11-02 사용자 요청. 강조는 뺌).
 *
 * 쓰는 곳: 로그인·가입 하단, 급여명세 포털 하단, 계정 메뉴 맨 아래.
 */
type Props = {
  className?: string;
};

export function LegalLinks({ className }: Props) {
  return (
    <nav className={`legal-links${className ? ` ${className}` : ""}`} aria-label="약관과 정책">
      <a href="/privacy.html" target="_blank" rel="noopener noreferrer">
        개인정보처리방침
      </a>
      <span aria-hidden="true">·</span>
      <a href="/terms.html" target="_blank" rel="noopener noreferrer">
        이용 규정
      </a>
    </nav>
  );
}
